import { combineReducers } from 'redux';
import { searchReducer } from './searchReducer';

const reducers = combineReducers({
  searchReducer: searchReducer,
});

export default reducers;
